module.exports = __webpack_public_path__ + "img/trash_delete.29e25a2f.png";